import { connect } from 'react-redux';
import EditAct from './EditAct';
import {
  addPieceToAct,
  addPieceToActClear,
  deleteAct,
  deleteActClear,
  deletePieceFromAct,
  deletePieceFromActClear,
  getActsByStock,
  getPiecesByAct,
  getPiecesByStock,
  setInitialStateActs,
  signActsByClient,
  updateAct,
  updateActClear,
  setVisiblePopupSignSelected
} from '../../store/actions/documents';
import { modalErrorOpen } from '../../store/actions/modalError';

const mapStateToProps = ({
  documentsReducer,
  tabsReducer
}) => ({
  documentsReducer,
  tabsReducer
});

const mapDispatchToProps = {
  getActsByStock,
  updateAct,
  updateActClear,
  deleteAct,
  deleteActClear,
  getPiecesByAct,
  getPiecesByStock,
  addPieceToAct,
  addPieceToActClear,
  deletePieceFromAct,
  deletePieceFromActClear,
  setInitialStateActs,
  signActsByClient,
  modalErrorOpen,
  setVisiblePopupSignSelected
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditAct);
